export const FILE_TYPE = {
  SIMPLE_TEXT: 'text',
  WORD: 'word',
  PPT: 'powerpoint',
  EXCEL: 'excel',
  PDF: 'pdf',
  IMAGE: 'image',
  ZIP: 'zip',
  CODE: 'code',
  AUDIO: 'audio',
  VIDEO: 'video',
  UNKNOWN: 'unknown',
};

/**
 * Return the file type category enum from a file's extension
 * @param {string} filename
 * @return {FILE_TYPE}
 */
export function getFileTypeCategory(filename) {
  const fileExtRegEx = /\.[0-9a-z]+$/i;
  let fileExt;
  try {
    const matches = filename.match(fileExtRegEx);
    fileExt = matches[0].toLowerCase();
  } catch {
    fileExt = null;
  }

  switch (fileExt) {
    case '.md':
    case '.rtf':
    case '.text':
    case '.txt':
      return FILE_TYPE.SIMPLE_TEXT;
    case '.doc':
    case '.docm':
    case '.docx':
    case '.dot':
    case '.dotx':
      return FILE_TYPE.WORD;
    case '.pot':
    case '.potm':
    case '.potx':
    case '.ppam':
    case '.pps':
    case '.ppsm':
    case '.ppsx':
    case '.ppt':
    case '.pptm':
    case '.pptx':
      return FILE_TYPE.PPT;
    case '.pdf':
      return FILE_TYPE.PDF;
    case '.bmp':
    case '.jpeg':
    case '.jpg':
    case '.png':
    case '.svg':
    case '.vsd':
      return FILE_TYPE.IMAGE;
    case '.7z':
    case '.arj':
    case '.deb':
    case '.gz':
    case '.pkg':
    case '.rar':
    case '.rpm':
    case '.tar':
    case '.z':
    case '.zip':
      return FILE_TYPE.ZIP;
    case '.csv':
    case '.xla':
    case '.xlam':
    case '.xll':
    case '.xlm':
    case '.xls':
    case '.xlsm':
    case '.xlsx':
    case '.xlt':
    case '.xltm':
    case '.xltx':
      return FILE_TYPE.EXCEL;
    case '.c':
    case '.cpp':
    case '.cs':
    case '.css':
    case '.exe':
    case '.h':
    case '.html':
    case '.jar':
    case '.java':
    case '.js':
    case '.json':
    case '.php':
    case '.py':
    case '.sh':
    case '.xml':
    case '.yaml':
      return FILE_TYPE.CODE;
    case '.aac':
    case '.aif':
    case '.cda':
    case '.flac':
    case '.mid':
    case '.midi':
    case '.mp3':
    case '.mpa':
    case '.ogg':
    case '.wav':
    case '.wma':
    case '.wpl':
      return FILE_TYPE.AUDIO;
    case '.3g2':
    case '.3gp':
    case '.amv':
    case '.asf':
    case '.avi':
    case '.drc':
    case '.f4a':
    case '.f4b':
    case '.f4p':
    case '.f4v':
    case '.flv':
    case '.gif':
    case '.gifv':
    case '.m2ts':
    case '.m2v':
    case '.m4p':
    case '.m4v':
    case '.mkv':
    case '.mng':
    case '.mov':
    case '.mp2':
    case '.mp4':
    case '.mpe':
    case '.mpeg':
    case '.mpg':
    case '.mpv':
    case '.mts':
    case '.mxf':
    case '.nsv':
    case '.ogv':
    case '.qt':
    case '.rm':
    case '.rmvb':
    case '.svi':
    case '.ts':
    case '.viv':
    case '.vob':
    case '.webm':
    case '.wmv':
    case '.yuv':
      return FILE_TYPE.VIDEO;
    default:
      return FILE_TYPE.UNKNOWN;
  }
}

/**
 * Zip files and saves to local drive
 * @param {array} files
 * @return {Promise}
 */
export function zipFiles(files) {
  const FileSaver = require('file-saver');

  const performZip = import('jszip').then((zip) => {
    const JSZip = zip.default;
    const zipped = new JSZip();
    files.forEach((file)=>{
      if (file.data) {
        zipped.file(file.filename, file.data, {base64: true});
      }
    });
    return zipped.generateAsync({type: 'blob'})
        .then(function(blob) {
          FileSaver.saveAs(blob, 'download.zip');
        })
        .catch((error) => {
          throw new Error('Unable to create zip attachments');
        });
  });
  return performZip;
};
